import React from "react";
import "../style.css";


const TextCell = ({ value }) => (
  <div className="table-text-cell" title={value}>
    {value}
  </div>
);

export const CORPORATE_MASTER_COLUMNS = [
  {
    Header: "Corporate Id",
    id: "corporateId",
    accessor: d => <TextCell value={d.corporateId} />
  },
  {
    Header: "Corporate Name",
    id: "corporateName",
    accessor: d => <TextCell value={d.corporateName} />
  },
  {
    Header: "Sales Associates",
    id: "salesAssociates",
    accessor: d => <TextCell value={d.salesAssociates} />
  },
  {
    Header: "Email",
    id: "salesAssociatesEmail",
    accessor: d => <TextCell value={d.salesAssociatesEmail} />
  },
  {
    Header: "Team Leader",
    id: "teamLeader",
    accessor: d => <TextCell value={d.teamLeader} />
  },
  {
    Header: "Region",
    id: "region",
    accessor: d => <TextCell value={d.region} />
  }
];

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_NUMBER = 0;